module.exports = __webpack_public_path__ + "static/media/2122-service-1-2-min.9fd93fc8.jpg";